/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { SoftwareVersion } from '@midas/shared/common';
import { createEntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as SofwareVersionActions from './software-versions.actions';

export const SOFTWARE_VERSIONS_KEY = 'softwareVersions';

export interface SoftwareVersionsState {
  versions: SoftwareVersion[]
}

export const softwareAdapter = createEntityAdapter<SoftwareVersion>();

const initialState: SoftwareVersionsState = {
  versions: [],
};

export const SoftwareVersionFeature = createFeature({
  name: SOFTWARE_VERSIONS_KEY,
  reducer: createReducer(
    initialState,
    on(SofwareVersionActions.getSoftwareVersionSuccess, (state, { versions }): SoftwareVersionsState => {
      return {
        ...state,
        versions: versions
      };
    }),

    on(SofwareVersionActions.deleteVersionSuccess, (state, { deletedVersionId }): SoftwareVersionsState => {
      const versionList = [...state.versions]
      versionList.splice(versionList.findIndex(v => v.id === deletedVersionId), 1)
      return {
        ...state,
        versions: [...versionList]
      };
    })
  ),
});


